import AdvertisingMediaAddForm from './AdvertisingMediaAddForm';

export default AdvertisingMediaAddForm;
